<ng-container *ngIf="state$ | async as state; else reportLoading">
	<!-- Title -->
	<div mat-dialog-title class="mat-dialog-header">
		<h2 class="dialog-title">Add Samples to report</h2>
	</div>
	<div mat-dialog-content>
        <form #reportLinkSamplesForm="ngForm" class="pv-form single-column" [formGroup]="formGroup" (ngSubmit)="attempt()">
            <mat-form-field appearance="fill">
                <mat-label>
                    <mat-icon svgIcon="common:flat_scion"></mat-icon>
                    <span>Filter Scion Cultivar(s)</span>
                </mat-label>
                <pv-cultivar-autocomplete-chips
                    [formControl]="scionCultivarsControl"
                    [orgKey]="state.orgKey">
                </pv-cultivar-autocomplete-chips>
            </mat-form-field>

			<mat-form-field class="report-select">
				<mat-label>Reports</mat-label>
				<mat-select formControlName="report" placeholder="None">
					<mat-select-trigger>
                        <ng-container *ngIf="selectedReport">
                            {{ selectedReport.title }}
                        </ng-container>
					</mat-select-trigger>
					<mat-option>
						<ngx-mat-select-search
                            [formControl]="searchControl"
							placeholderLabel="Find Reports..."
							noEntriesFoundLabel="No matching Reports found">
 						</ngx-mat-select-search>
					</mat-option>
					<mat-option *ngFor="let report of state.reports" [value]="report.key" (click)="selectedReport = report">
                        <div class="report-option">
                            <div class="report-title-wrapper">
                                <mat-icon matListIcon>insert_chart</mat-icon>
                                <span class="report-title">{{ report.title }}</span>
                            </div>
                            <span>{{ report.updatedAt | date:'mediumDate'}}</span>
                        </div>
				   </mat-option>
				</mat-select>
				<mat-hint>Select Report</mat-hint>
				<mat-error>A Report is required to continue</mat-error>
			</mat-form-field>
		</form>
	</div>
	<!-- Actions -->
	<pv-form-actions
        mat-dialog-actions
        [form]="reportLinkSamplesForm"
        (cancel)="cancel()"
        [status]="state.status">
	</pv-form-actions>
</ng-container>
<ng-template #reportLoading>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>